// i18n 初始化
// 关键：客户端从 localStorage 读上次选择的 locale，避免刷新时回到默认
import { createI18n } from 'vue-i18n'
import { DEFAULT_LOCALE, STORAGE_KEY, SUPPORTED_LOCALES } from '@/config'
import zhCN from './locales/zh-CN'
import zhTW from './locales/zh-TW'
import en from './locales/en'

function detectInitialLocale(): string {
  if (typeof window === 'undefined') return DEFAULT_LOCALE
  // 优先 URL ?lang= > localStorage > 浏览器语言 > 默认
  // 各路分别 try/catch，单个失败不影响其他
  try {
    const url = new URL(window.location.href)
    const urlLang = url.searchParams.get('lang')
    if (urlLang && (SUPPORTED_LOCALES as readonly string[]).includes(urlLang)) {
      return urlLang
    }
  } catch {
    // URL 解析失败
  }
  try {
    // 跟 locale store 用同一把 key（STORAGE_KEY.locale = 'yfb.locale'）
    const saved = localStorage.getItem(STORAGE_KEY.locale)
    if (saved && (SUPPORTED_LOCALES as readonly string[]).includes(saved)) {
      console.log('[YFB][i18n] init locale from localStorage:', saved)
      return saved
    }
  } catch {
    // localStorage 读失败
  }
  console.log('[YFB][i18n] init locale default:', DEFAULT_LOCALE)
  return DEFAULT_LOCALE
}

export const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    en
  }
})

export default i18n
